import React from 'react';
import { PhoneIcon, CheckCircle2Icon, ClockIcon, ShieldCheckIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-[#0a1628] text-white pt-32 pb-20 px-4 md:px-8 overflow-hidden" data-id="element-88">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-full h-full opacity-10 pointer-events-none" data-id="element-89">
        <div className="absolute top-20 right-[-10%] w-[500px] h-[500px] bg-blue-500 rounded-full blur-[120px]" data-id="element-90"></div>
        <div className="absolute bottom-0 left-[-10%] w-[400px] h-[400px] bg-orange-500 rounded-full blur-[100px]" data-id="element-91"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10 text-center flex flex-col items-center" data-id="element-92">
        <div className="inline-block bg-orange-500/20 text-orange-300 px-4 py-1 rounded-full text-sm font-bold mb-6 border border-orange-500/30" data-id="element-93">
          ⚡ שירות חירום 24/7 - מגיעים תוך 60 דקות
        </div>

        <h1 className="text-5xl md:text-7xl font-black leading-tight mb-6" data-id="element-94">
          נזקי רטיבות? <br data-id="element-95" />
          <span className="text-[#f97316]" data-id="element-96">אנחנו מייבשים</span> <br data-id="element-97" />
          לפני שהנזק מחמיר.
        </h1>

        <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-98">
          טכנולוגיית ייבוש מתקדמת לרצפות, קירות וגגות – עוצרים את הרטיבות,
          מונעים עובש ומצילים את הנכס. תוצאות מוכחות תוך 24 שעות.
        </p>

        <div className="mb-10" data-id="element-99">
          {/* Stack on mobile, side by side on sm+ */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6" data-id="element-100">
            <a href="tel:0523552222" className="inline-flex items-center gap-2 text-3xl md:text-5xl lg:text-6xl font-black text-[#f97316] hover:text-orange-400 transition-colors" data-id="element-101">
              <PhoneIcon className="w-7 h-7 md:w-10 md:h-10 animate-pulse flex-shrink-0" data-id="element-102" />
              <span dir="ltr" data-id="element-103">052-355-2222</span>
            </a>
            <span className="text-gray-500 text-2xl hidden sm:inline" data-id="element-104">|</span>
            <a href="tel:0545188888" className="inline-flex items-center gap-2 text-3xl md:text-5xl lg:text-6xl font-black text-[#f97316] hover:text-orange-400 transition-colors" data-id="element-105">
              <PhoneIcon className="w-7 h-7 md:w-10 md:h-10 animate-pulse flex-shrink-0" data-id="element-106" />
              <span dir="ltr" data-id="element-107">054-518-8888</span>
            </a>
          </div>
          <p className="text-gray-400 mt-2 text-sm" data-id="element-108">
            שיחת ייעוץ חינם ללא התחייבות
          </p>
        </div>

        <div className="flex flex-col gap-3 w-full max-w-sm md:max-w-none md:flex-row justify-center mb-12" data-id="element-109">
          <a href="tel:0523552222" className="bg-[#f97316] hover:bg-orange-600 text-white px-8 py-4 text-lg font-bold rounded-lg shadow-lg shadow-orange-500/30 transition-all transform hover:scale-105 flex items-center justify-center gap-2" data-id="element-110">
            <PhoneIcon className="w-5 h-5" data-id="element-111" />
            052-355-2222
          </a>
          <a href="tel:0545188888" className="bg-[#f97316] hover:bg-orange-600 text-white px-8 py-4 text-lg font-bold rounded-lg shadow-lg shadow-orange-500/30 transition-all transform hover:scale-105 flex items-center justify-center gap-2" data-id="element-112">
            <PhoneIcon className="w-5 h-5" data-id="element-113" />
            054-518-8888
          </a>
          <a href="https://wa.me/9720523552222" target="_blank" rel="noopener noreferrer" className="border-2 border-white/30 hover:border-white hover:bg-white/5 text-white px-8 py-4 text-lg font-bold rounded-lg transition-all flex items-center justify-center" data-id="element-114">
            קבלו הצעת מחיר בוואטסאפ
          </a>
        </div>

        {/* Trust Badges */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-12 border-t border-white/10 pt-10 w-full max-w-4xl" data-id="element-115">
          <div className="flex items-center justify-center gap-3" data-id="element-116">
            <CheckCircle2Icon className="w-6 h-6 text-[#f97316]" data-id="element-117" />
            <span className="font-bold text-lg" data-id="element-118">15 שנות ניסיון</span>
          </div>
          <div className="flex items-center justify-center gap-3" data-id="element-119">
            <ClockIcon className="w-6 h-6 text-[#f97316]" data-id="element-120" />
            <span className="font-bold text-lg" data-id="element-121">500+ לקוחות מרוצים</span>
          </div>
          <div className="flex items-center justify-center gap-3" data-id="element-122">
            <ShieldCheckIcon className="w-6 h-6 text-[#f97316]" data-id="element-123" />
            <span className="font-bold text-lg" data-id="element-124">אחריות מלאה בכתב</span>
          </div>
        </div>
      </div>
    </section>;
}